<template>
    <div style="width: 100%">
        <ion-row>
            <ion-col size="2" class="center-x px-1">
                <div class="icon-container center-x">
                    <img v-if="entry.imageLink" alt=""
                        :src="(entry.imageLink.startsWith('/')) ? `https://app.octopusorder.com${entry.imageLink}` : entry.imageLink"
                        style="max-height: 100%;" />
                    <ion-icon v-else src="assets/icon/item.svg" class="max-size purple-purple-color" />
                </div>
            </ion-col>

            <ion-col class="center-x flex-d-c">
                <ion-row>
                    <ion-col class="p-0 fw-b">
                        {{ entry.name }}
                    </ion-col>
                </ion-row>

                <ion-row class="mt-1">
                    <ion-col class="fs-smaller grey1-grey1-color p-0">
                        {{ entry.packaging }}
                    </ion-col>
                </ion-row>

                <ion-row class="mt-1">
                    <ion-col class="fs-smaller grey1-grey1-color p-0">
                        {{ $t('label.articleNo') }}: {{ entry.itemNumber }}
                    </ion-col>
                </ion-row>
            </ion-col>

            <ion-col v-if="edit" size="auto" class="center-y">
                <button-base :color="ION_VARIANT.GREY_4" class="round-button grey1-grey1-color inherit-color no-shadow"
                    style="width: 50px; height: 50px;" @click="handleEditClick">
                    <ion-icon src="assets/icon/pencil.svg" class="round-button-icon" />
                </button-base>
            </ion-col>
        </ion-row>

        <ion-row v-if="entry.quantity" class="stacked-cols px-2">
            <ion-col size="3" class="fixed-width-xxs-screen">
                <div class="fs-smaller grey1-grey1-color">
                    {{ $t('object.amount') }}
                </div>
                <div class="fw-b fs-smaller">
                    {{ entry.quantity }}
                </div>
            </ion-col>

            <ion-col v-if="entry.price">
                <div class="fs-smaller grey1-grey1-color">
                    {{ $t('object.price') }}
                </div>
                <div class="fw-b fs-smaller">
                    {{ convertNumberWithComma(Number(entry.price).toFixed(3)) }} {{ CURRENCY_EUR }}
                </div>
            </ion-col>

            <ion-col v-if="total" size="4" class="ion-text-end"></ion-col>
        </ion-row>
    </div>
</template>

<script setup lang="ts">
import { IonRow, IonCol, IonIcon } from '@ionic/vue';
import { computed } from 'vue';

import ButtonBase from "@/components/button/ButtonBase.vue";

import { convertNumberWithComma } from "@/functions/converter";

import { ION_VARIANT } from '@/types/enum/ionicEnum';
import { CatalogItem } from '@/types/supplier';
import { CURRENCY_EUR } from "@/assets/variables";
import { HIGHLIGHT_COLOR, HIGHLIGHT_MESSAGE } from "@/types/enum/propEnum";
import convertFormat from "@/functions/luxon";
import { DATE_TIME_FORMAT } from "@/types/enum/luxonEnum";
import HighlightBox from "@/components/card/HighlightBox.vue";
import SkeletonBase from "@/components/various/SkeletonBase.vue";

interface ScanDetailsEntryProps {
    entry: CatalogItem;
    edit?: boolean;
}

const props = defineProps<ScanDetailsEntryProps>()
const emit = defineEmits<{ (e: 'edit'): void }>()

const total = computed<number>(() => Number(props.entry.quantity ?? 0) * Number(props.entry.price))

const handleEditClick = (event: TouchEvent | MouseEvent): void => {
    event.stopPropagation()
    emit('edit')
}
</script>
